import { gql, useMutation } from '@apollo/client'

const SetMarketingOptIn = gql`
  mutation SetMarketingOptIn($marketingOptInAt: ISO8601DateTime) {
    setMarketingOptIn(marketingOptInAt: $marketingOptInAt) {
      success
      message
    }
  }
`

export const useSetMarketingOptIn = () => {
  const [setMarketingOptInMutation, { data, loading, error }] = useMutation(
    SetMarketingOptIn,
  )

  const setMarketingOptIn = marketingOptInChecked => {
    const marketingOptInAt = marketingOptInChecked
      ? (() => {
        const date = new Date()
        date.setSeconds(0, 0)
        return date.toISOString()
      })()
      : null

    setMarketingOptInMutation({
      variables: { marketingOptInAt },
    })
  }

  return { setMarketingOptIn, data, loading, error }
}
